<template>
    <div
      class="medium-9 cell"
      v-if="loaded"
    >

      <nav>

     <ul class="nav nav-primary"> 
          <li v-if="identity.type == 'Intermediary'"  :class="{'current':($route.meta.activeMenu === 'Intermediary')}">
            <a href="/clients/">Projects</a>
          </li>
          <li v-if="identity.type == 'Administrator'"  :class="{'current':($route.meta.activeMenu === 'Admin')}">
            <a href="/admin/clients/">Projects</a>
          </li>
          <li v-if="identity.isAuthenticated && project.projectId != null && project.projectId != ''" :class="{'current':($route.meta.activeMenu === 'ClientProject')}">
            <a href="/">Dashboard</a>
          </li>
        <li  v-if="identity.isAuthenticated" :class="{'current':($route.meta.activeMenu === 'Account')}">
          <router-link to="/Account">      
            <span class="user-circle">M</span>
          </router-link>
        </li>
        <li>
          <!--<NotificationBell />-->
        </li> 
      </ul>
      </nav>
    </div>
  </template>
  
  <script>
  //import NotificationBell from "@/components/common/notification/NotificationBell.vue";
  import { useIdentityStore } from '@/stores/identity';
  import { useProjectStore } from '@/stores/project.js'

  export default {
      name: "NavigationBar",
      components: {
        //NotificationBell
      },
        data() {
          return {
            loaded: false,
            identity: null,
            project: null
          };
        },
      mounted() {

       this.identity = useIdentityStore();
       this.project = useProjectStore();
       this.loaded = true;


      },
      methods: {

        async logOut()
        {
          await this.logout();
        }
      }
  }
  
  </script>
  
  <style>
  
  </style>